export default {
  getList: state => state.list,
  getCondition: state => state.condition,
  getSearchType: state => state.condition.searchType,
  getDetail: state => state.detail,
  getBackground: state => state.backgroundList,
  getFrame: state => state.frameList,
  getStepOne: state => state.register.step1,
  getStepTwo: state => state.register.step2,
  getStepThree: state => state.register.step3,
  getRegister: state => state.register,
  getCommentList: state => state.commentList,
  getCommentCondition: state => state.commentCondition,
  getPageInfo: state => state.pageInfo,
  getAliveCondition: state => state.aliveCondition,
  getAnniversaryList: state => state.anniversaryList,

  getAliveList: state => state.aliveList,
  getAliveDetail: state => state.aliveDetail
};
